import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { UserDto, UserInputDto, UserService } from 'src/app/proxy/users';

@Component({
  selector: 'app-user-autocomplete',
  standalone: false,
  templateUrl: './user-autocomplete.component.html',
})
export class UserAutocompleteComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() disabled: boolean;

  @Output() changeSelectedUser = new EventEmitter<UserDto>();
  users: UserDto[];
  selectedUser: UserDto;

  private selectedUserId: string;
  
  constructor(
    injector: Injector,
    private readonly _userService: UserService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadUsers();
    this.onChangeSelectedUser();
  }

  async loadUsers(filter: AutoCompleteCompleteEvent = null): Promise<void> {
    try {
      this.showLoading();

      const inputDto: UserInputDto = {
        filter: filter?.query
      };

      this.users = await firstValueFrom(this._userService.getAllUsersByInput(inputDto));
      this.setUserSelectedIfCorrespond();
    } finally {
      this.hideLoading();
    }
  }

  onChangeSelectedUser(): void {
    this.changeSelectedUser.emit(this.selectedUser);
  }

  setSelectedUserId(userId: string): void {
    this.selectedUserId = userId;
    if (this.users && this.users.length > 0) {
      this.selectedUser = this.users.find(user => user.id === userId);
    }
  }

  setSelectedUser(user: UserDto | undefined): void {
    this.selectedUser = user;
    this.selectedUserId = user?.id;
    this.changeSelectedUser.emit(this.selectedUser);
  }

  private setUserSelectedIfCorrespond(): void {
    if (this.selectedUserId) {
      this.selectedUser = this.users.find(user => user.id === this.selectedUserId);
    }
  }
}
